// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__2OGVw","calendarButtons":"ClockData_calendarButtons__1rS9Z"};